import { useCallback, useRef } from 'react';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { rawTrackViewEvent } from '../../../../services/tracking/pulse';
import { pascalCaseToKebabCase } from '../../../../utils/string';
import { trackClickEvent } from '../../../../services/tracking/pulseEvents';
import { getStoryUrl } from '../../../../shared/helpers/routes';

export const useTracking = ({
  elementType,
  pageComponentIndex,
  header,
}: {
  elementType: string;
  pageComponentIndex: number;
  header?: string;
}) => {
  const trackingStateRef = useRef<'idle' | 'viewed'>('idle');

  const trackSliderView = useCallback(() => {
    if (trackingStateRef.current !== 'idle') {
      return;
    }

    rawTrackViewEvent({
      object: {
        id: pascalCaseToKebabCase(elementType),
        type: 'UIElement',
        name: header,
        elementType,
        position: String(pageComponentIndex),
      },
    });

    trackingStateRef.current = 'viewed';
  }, [elementType, header, pageComponentIndex]);

  const trackStoryClick = useCallback(
    (asset: SvpAssetAdditional, columnIndex: number) => {
      if (trackingStateRef.current !== 'viewed') {
        return;
      }

      const url = getStoryUrl(asset.id);

      const parent = {
        elementType,
        header,
        row: pageComponentIndex,
      };

      const object = {
        id: asset.id,
        title: asset.title,
        elementType: 'Story',
        position: columnIndex,
        url,
      };

      const target = {
        id: asset.id,
        title: asset.title,
        type: 'Story',
        url,
      };

      trackClickEvent(parent, object, target);
    },
    [elementType, header, pageComponentIndex]
  );

  return {
    trackSliderView,
    trackStoryClick,
  };
};
